<template>
  <div class="navigation-menu-ctn" :class="{ 'collapsed': isCollapsed, 'is-mobile': isMobile }">
    <div class="nav-menu-header-ctn">
      <div class="header-content" @click="navigateTo('/products')">
        <scantrust-pro-logo-icon size="32" class="logo-icon"></scantrust-pro-logo-icon>
        <scantrust-pro-text-icon size="115" class="text-logo"></scantrust-pro-text-icon>
      </div>

      <div v-if="!isMobile" class="collapse-btn" @click="toggleCollapse">
        <v-icon>{{ isCollapsed ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
      </div>
    </div>

    <nav class="nav-list">
      <div class="nav-items-container">
        <div class="nav-item" @click="navigateTo('/products')" :class="{ 'active': isActive('/products') }" :title="isCollapsed ? $t('navigation_products') : ''">
          <div class="nav-item-icon">
            <product-icon :color="isActive('/products') ? '#0070b6' : 'black'"></product-icon>
          </div>
          <div class="nav-item-title">{{ $t('navigation_products') }}</div>
        </div>

        <!-- <div class="nav-item" @click="navigateTo('/landing-pages')" :class="{ 'active': isActive('/landing-pages') }">
          <div class="nav-item-icon">
            <landing-page-icon :color="isActive('/landing-pages') ? '#0070b6' : 'black'"></landing-page-icon>
          </div>
          <div class="nav-item-title">{{ $t('navigation_landing_pages') }}</div>
        </div> -->

        <div class="nav-item" @click="navigateTo('/gallery')" v-if="totalCodesCount || usedCodesCount" :class="{ 'active': isActive('/gallery') }" :title="isCollapsed ? $t('navigation_gallery') : ''">
          <div class="nav-item-icon">
            <gallery-icon :color="isActive('/gallery') ? '#0070b6' : 'black'"></gallery-icon>
          </div>
          <div class="nav-item-title">{{ $t('navigation_gallery') }}</div>
        </div>

        <div class="nav-item" @click="navigateTo('/')" :class="{ 'active': isActive('/') }" :title="isCollapsed ? $t('navigation_dashboard') : ''">
          <div class="nav-item-icon">
            <dashboard-icon :color="isActive('/') ? '#0070b6' : 'black'"></dashboard-icon>
          </div>
          <div class="nav-item-title">{{ $t('navigation_dashboard') }}</div>
        </div>

        <div class="nav-item" @click="navigateTo('/upgrade?source=menu')" :class="{ 'active': isActive('/upgrade') }" :title="isCollapsed ? $t('navigation_plans') : ''">
          <div class="nav-item-icon">
            <v-icon :color="isActive('/upgrade') ? 'primary' : 'black'">mdi-credit-card-outline</v-icon>
          </div>
          <div class="nav-item-title">{{ $t('navigation_plans') }}</div>
        </div>
      </div>
      <div class="nav-profile-container">
        <profile-navigation-btn :is-collapsed="isCollapsed"></profile-navigation-btn>
      </div>
    </nav>
  </div>
</template>

<script>
import amplitude from 'amplitude-js'
import { mapGetters } from 'vuex'
import ProfileNavigationBtn from '@/components/profile/ProfileNavigationBtn'
import ScantrustProTextIcon from '@/components/icons/ScantrustProText'
import ScantrustProLogoIcon from '@/components/icons/ScantrustProLogo'
import ProductIcon from '@/components/icons/Product'
import GalleryIcon from '@/components/icons/Gallery'
import DashboardIcon from '@/components/icons/Dashboard'
// import LandingPageIcon from '@/components/icons/LandingPage'

export default {
  name: 'NavigationMenu',
  props: ['active', 'isMobile'],
  components: {
    ProfileNavigationBtn,
    ScantrustProTextIcon,
    ScantrustProLogoIcon,
    ProductIcon,
    GalleryIcon,
    DashboardIcon
    // LandingPageIcon
  },
  data () {
    return {
      isCollapsed: false
    }
  },
  computed: {
    ...mapGetters(['totalCodesCount', 'usedCodesCount'])
  },
  methods: {
    navigateTo (path) {
      this.$router.push(path).catch(() => {})
      this.$emit('close')
    },

    isActive (path) {
      return this.$route.path === path
    },

    toggleCollapse () {
      this.isCollapsed = !this.isCollapsed
      this.saveCollapsedState()
      this.$emit('toggle-collapse', this.isCollapsed)
    },

    saveCollapsedState () {
      try {
        localStorage.setItem('navigation_menu_collapsed', JSON.stringify(this.isCollapsed))
      } catch (error) {
        console.warn('Failed to save navigation collapsed state to localStorage:', error)
      }
    },

    loadCollapsedState () {
      try {
        const saved = localStorage.getItem('navigation_menu_collapsed')
        if (saved !== null) {
          this.isCollapsed = JSON.parse(saved)
        }
      } catch (error) {
        console.warn('Failed to load navigation collapsed state from localStorage:', error)
        this.isCollapsed = false
      }
    },

    sendNavigationEvent (tabName) {
      amplitude.getInstance().logEvent(`${tabName} open`)
      parent.postMessage({ type: 'navigation', data: tabName }, '*')
    }
  },
  created () {
    if (!this.isMobile) {
      this.loadCollapsedState()
    } else {
      this.isCollapsed = false
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/variables.sass'

.navigation-menu-ctn
  height: 100%
  background: $light-bg
  display: flex
  flex-direction: column
  width: 194px
  transition: width 0.3s ease
  overflow: visible
  &.is-mobile
    width: auto !important
  &.collapsed
    width: 72px

.nav-menu-header-ctn
  position: relative
  flex-shrink: 0
  display: flex
  align-items: center
  justify-content: space-between
  padding: 0px
  background: $light-bg
  border-bottom: 1px solid rgba(0, 0, 0, 0.1)
  min-height: 50px

.header-content
  cursor: pointer
  display: flex
  align-items: center
  overflow: hidden
  flex: 1
  padding-left: 14px
  transition: padding-left 0.2s ease
  .collapsed &
    padding-left: 20px

.logo-icon
  flex-shrink: 0

.text-logo
  margin-left: 8px
  transition: opacity 0.2s ease
  overflow: hidden
  .collapsed &
    opacity: 0

.collapse-btn
  position: absolute
  z-index: 1000
  cursor: pointer
  background: white
  padding: 4px
  transition: all 0.3s ease
  margin-left: 8px
  right: -15px
  bottom: -17px
  border-radius: 50%
  z-index: 1000
  border: 1px solid rgba(0, 0, 0, 0.1)

  &:hover
    background-color: $light-bg

.nav-list
  display: flex
  flex-direction: column
  flex: 1
  min-height: 0
  background: $light-bg

.nav-items-container
  flex: 1
  overflow-y: auto
  padding: 4px 0
  min-height: 0

.nav-profile-container
  flex-shrink: 0
  margin-top: auto
  padding: 4px 0

.nav-item
  display: flex
  align-items: center
  padding: 8px 16px
  cursor: pointer
  background: $light-bg
  transition: all 0.3s ease
  user-select: none
  min-height: 40px
  white-space: nowrap

  .collapsed &
    padding: 8px
    justify-content: center

  &:hover
    background-color: rgba(0, 0, 0, 0.04)

  &.active
    color: $primary !important
    background-color: #0070B61A

    .nav-item-title
      font-weight: 700 !important
      color: $primary

.nav-item-icon
  display: flex
  align-items: center
  justify-content: flex-start
  margin-right: 16px
  min-width: 24px
  width: 24px
  flex-shrink: 0
  transition: margin-right 0.3s ease

  .collapsed &
    margin-right: 0
    justify-content: center

.nav-item-title
  font-size: 14px
  font-weight: 400
  line-height: 1.25
  letter-spacing: 0.0178571429em
  flex: 1
  overflow: hidden
  transition: all 0.3s ease
  max-width: 200px

  .collapsed &
    opacity: 0
    max-width: 0
    margin: 0
    padding: 0

</style>
